// HighlyTrainedCaregiversSection.js
import React from 'react';
import trainedCaregiversImage from '../assets/highly-trained-caregivers-image.jpg';

const HighlyTrainedCaregiversSection = () => {
  return (
    <section className="bg-white overflow-hidden">
      {/* Calm cream intro band */}
      <div className="bg-bnCream py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            B & N Enterprise Home Care
          </p>
          <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
            Proudly Caring for Canberra's Seniors, One Home at a Time
          </h2>
          <p className="text-bnBody text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            At B & N Enterprise, we believe every older person deserves to feel valued, respected, and supported in the place they call home. Our carers provide personalised support that encourages safety, independence, and companionship, helping families across Canberra find peace of mind while their loved ones live life to the fullest.
          </p>
        </div>
      </div>

      {/* Image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative">
            <img
              src={trainedCaregiversImage}
              alt="A carer supporting an older woman"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl mb-6">
              Our Highly Trained Carers Understand Dementia
            </h3>

            <div className="space-y-4 text-bnBody text-base leading-relaxed max-w-lg">
              <p>
                At B & N Enterprise, we make it simple to find the right services and the right carer for your loved one.
              </p>

              <p>
                Upon contacting us, we will arrange a free consultation without any obligations. This consultation will allow us to comprehensively understand your loved one's situation and build the groundwork for their care plan. We will also address any queries you may have about in-home care.
              </p>

              <p>
                During the consultation, we can discuss your loved one's care schedule and create an initial care plan. The care schedule will be designed based on your loved one's established routines and may include part-time, full-time, or round-the-clock caregiving. We can also accommodate care for any family members who reside with your loved one or conduct regular care visits.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlyTrainedCaregiversSection;
